import { render, staticRenderFns } from "./cartsList.vue?vue&type=template&id=4ac14b16&"
import script from "./cartsList.vue?vue&type=script&lang=js&"
export * from "./cartsList.vue?vue&type=script&lang=js&"
import style0 from "./cartsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports